<template>
  <div class="main">
    <div class="tablediv"
        v-loading="zhifuDisable"
        element-loading-text="正在生成支付码"
        element-loading-spinner="el-icon-loading">
      <div class="total-title">
        <span class="top-title">购买服务</span>
        <div style="float:right;clear:both;">
          <!-- <span class="orderNo">
            订单号
            <span class="orderNo"></span>
          </span> -->
        </div>
      </div>
      <el-row class="row-style">
        <el-col :span="6" class="select-title">
          <span>选择设备</span>
        </el-col>
        <el-col :span="18" :offset="6">
          <el-input size="mini" style="width:165px" v-model="no" class="elmargin" placeholder="印宝编号" clearable></el-input>
          <el-input size="mini" style="width:165px" v-model="dvalias" class="elmargin" placeholder="别名" clearable></el-input>
          <el-select size="mini" v-model="status" style="width:105px" class="elmargin" placeholder="服务" clearable>
            <el-option
                v-for="item in statusList"
                :key="item.code"
                :label="item.content"
                :value="item.code"
            ></el-option>
          </el-select>
          <el-button class="primarybtn" type="primary" size="mini" @click="query">筛选</el-button>
          <el-button size="mini" @click="reset">重置</el-button>
        </el-col>
      </el-row>
      <div class="tablepad">
        <el-table
          :data="deviceList"
          style="width: 100%"
          empty-text="暂无设备"
          header-row-class-name="tableHead"
          :header-cell-style="{'background-color':'#8D99AB'}"
          cell-class-name="tableTbody"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="dvsno" label="印宝编号">
            <template slot-scope="scope">
              <span class="yinbaono">{{scope.row.dvsno}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="dvalias" label="印宝别名"></el-table-column>
          <el-table-column prop="service" label="购买前有效期"></el-table-column>
        </el-table>
        <el-row>
          <el-col :span="16" class="Settlement-left">
            <span>
              已选择
              <span class="orange">{{multipleSelection.length}}</span>台印宝
            </span>
            <span style="margin-left:30px;font-size:18px">
              <el-radio-group v-model="model" size="small" @change="modelChange">
                <el-radio-button label="按年">年</el-radio-button>
                <el-radio-button label="按月">月</el-radio-button>
              </el-radio-group>
            </span>
            <span style="margin-left:40px">
              单价
              <span class="orange">{{unitprice}}{{unitname}}</span>
            </span>
          </el-col>
          <el-col :span="8" class="Settlement-right">
            <span>
              购买
              <el-input v-model="amount" class="year" size="small" @change="amountChange" onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"></el-input>{{model=="按年" ? "年" : "月"}}服务
            </span>
            <div class="el-form-item__error" v-if="model=='按年' && amount>10">
                购买年数最大为10年
            </div>
            <div class="el-form-item__error" v-if="model=='按月' && amount>24">
                购买月数最大为24个月
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="totalprice">
            <span>
              应付总价
              <span class="orange">{{totalprice}}</span>元
            </span>
            <br />
            <el-button type="primary" class="paybtn primarybtn" @click="save('微信')" :disabled="zhifuDisable">微信支付</el-button>
            <el-button type="primary" class="paybtn primarybtn" @click="save('支付宝')" :disabled="zhifuDisable">支付宝支付</el-button>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible" width="300px" :before-close="handleClose">
      <div class="paydialog-content">
        <div class="QRcode" v-qr="qrcode" v-if="dialogVisible"></div>
        <div style="text-align: center;margin-top: 16px;">
          <label class="pay-lb3">{{dialogTitle}}</label>
        </div>
      </div>
    </el-dialog>
  </div>
  <!-- </div> -->
</template>

<script>
import util from "../components/util";
export default util.useCommon({
  data() {
    return {
      ordersum: 0,
      unitname: "",
      unitprice: 0,
      amount: "1",
      model: "按年",
      totalprice: 0,
      deviceList: [],
      multipleSelection: [],
      no: "",
      dvalias:"",
      status: "",
      statusList: [
        {
          code:"0",
          content: "已过期"
        },
        {
          code:"1",
          content: "将过期"
        },
        {
          code: "2",
          content: "正常"
        }
      ],
      dialogVisible: false,
      dialogTitle:"",
      qrcode: {
        text: '',
        render: "canvas",
        width: 260,
        height: 260,
        typeNumber: -1,
        correctLevel: 2,
        background: "#ffffff",
        foreground: "#000000"
      },
      zhifuDisable: false,//支付
      bid :"",
    };
  },
  computed: {},
  methods: {
    reset(){
      var v = this;
      v.no = "";
      v.dvalias = "";
      v.status = "";
      v.query();
      v.getPrice();
    },
    query() {
      //查询设备列表
      var v = this;
      v.dopost(
        "/mydevice/getDevice",
        {
          owner :v.owner,
          dvsno: v.no,
          dvalias : v.dvalias,
          dvstatus: "",
          status: v.status
        },
        function(result) {
          if ("0000" === result.state) {
            v.deviceList = result.body.list;
          } else {
            var msg = [];
            for (var i = 0; i < result.body.length; i++) {
              msg.push(result.body[i].errmsg);
            }
            v.message("error", msg.join("<br/>"));
          }
          console.log(result);
        }
      );
    },
    amountChange(){
      var v = this;
      v.totalprice = v.ordersum * v.unitprice * v.amount;
    },
    modelChange(){
      var v = this;
      v.getPrice();
      
    },
    getPrice() {
      var v = this;
      v.dopost(
        "/order/getPrice",
        {
          gmodel:v.model,
          gtype :0
        },
        function(result) {
          if ("0000" === result.state) {
            v.unitprice = result.body.unitprice;
            v.unitname = result.body.unitname;
            v.totalprice = v.ordersum * v.unitprice * v.amount;
          } else {
            var msg = [];
            for (var i = 0; i < result.body.length; i++) {
              msg.push(result.body[i].errmsg);
            }
            v.message("error", msg.join("<br/>"));
          }
          console.log(result);
        }
      );
    },
    save(type){
      var v = this;
      v.qrcode.text ='';
      var checkMsg = [];
      if (v.model=='按年' && v.amount>10){
        checkMsg.push("购买年数最大为10年");
      } else if (v.model=='按月' && v.amount>24){
        checkMsg.push("购买月数最大为24个月");
      }

      if(checkMsg.length>0){
        return;
      }
      if (v.totalprice > 0 && checkMsg.length==0){
        v.zhifuDisable = true;
        v.dopost(
        "/order/save",
        {
          multipleSelection:v.multipleSelection,
          owner :v.owner,
          type:type,
          model:v.model,
          amount:v.amount,
          unitprice :v.unitprice,
          totalprice :v.totalprice
        },
        function(result) {
          if ("0000" === result.state) {
            v.bid= result.body.bid;
            if(type == '支付宝'){
                v.dopost("/order/alipay",
                  {
                    rechargeid: v.bid,
                    price: v.totalprice
                  },
                  function(paydata) {
                    if ("0000" === paydata.state) {
                      v.qrcode.text = paydata.body.qrCode;
                      v.dialogVisible = true;
                      v.dialogTitle = "使用支付宝扫码付款";
                      var interval = window.setInterval(function() {
                        v.dopost("/order/getPayStatus",{bid:v.bid,tsch:"ali"},function(statusdata) {
                          if ("0000" === statusdata.state) {
                            if(statusdata.body=="1"){
                              v.dialogVisible = false;
                              window.clearInterval(interval);
                              v.message("success", "支付成功！");
                              v.$router.replace("/myOrder");
                            }
                          }
                        });                      
                      }, 30000);//30秒刷一次
                    } else {
                      var msg = [];
                      for (var i = 0; i < paydata.body.length; i++) {
                        msg.push(paydata.body[i].errmsg);
                      }
                      v.message("error", msg.join("<br/>"));
                    }
                    v.zhifuDisable = false;
                    console.log(paydata);
                  });
            }else{
              // 微信支付
              v.dopost("/order/wxpay",
                  {
                    rechargeid: v.bid,
                    price: v.totalprice*100
                  },
                  function(paydata) {
                    if ("0000" === paydata.state) {
                      v.qrcode.text = paydata.body.qrCode;
                      v.dialogVisible = true;
                      v.dialogTitle = "使用微信扫码付款";
                      var interval = window.setInterval(function() {
                        v.dopost("/order/getPayStatus",{bid:v.bid,tsch:"wx"},function(statusdata) {
                          if ("0000" === statusdata.state) {
                            if(statusdata.body=="1"){
                              v.dialogVisible = false;
                              window.clearInterval(interval);
                              v.message("success", "支付成功！");
                              v.$router.replace("/myOrder");
                            }
                          }
                        });                      
                      }, 30000);//30秒刷一次
                    } else {
                      var msg = [];
                      for (var i = 0; i < paydata.body.length; i++) {
                        msg.push(paydata.body[i].errmsg);
                      }
                      v.message("error", msg.join("<br/>"));
                    }
                    v.zhifuDisable = false;
                    console.log(paydata);
                  });
            }
          } else {
            var msg = [];
            for (var i = 0; i < result.body.length; i++) {
              msg.push(result.body[i].errmsg);
            }
            v.message("error", msg.join("<br/>"));
            
          }
          v.zhifuDisable = false;
          console.log(result);
        });
      }
      
    },
    handleClose(done) {
        this.$confirm('确认放弃本次支付？')
            .then(_ => {
              done();
              this.$router.replace("/myOrder");
            })
            .catch(_ => {});
    },
    handleSelectionChange(val) {
      var v = this;
      v.multipleSelection = val;
      v.ordersum = v.multipleSelection.length;
      console.log(v.multipleSelection);
      v.totalprice = v.ordersum * v.unitprice * v.amount;
    }
  },
  created: function() {},
  activated() {
    var v = this;
    if (!v.nyy.userInfo) {
      v.$router.replace("/");
    }else{
      v.zhifuDisable = false;
      v.owner = v.nyy.userInfo.owner;
      v.corp = v.nyy.userInfo.corp;
      v.query();
      v.getPrice();
    }
  },
  mounted() {}
});
</script>
<style scoped>
.paydialog-content{
  height: 300px;
}
.QRcode{
  width: 260px;
  height: 260px;
  margin: 10px auto;
  margin-bottom: 0px;
}
.pay-lb3{
  font-size: 12px;
}
.orderNo {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #8295ae;
}
.main {
  overflow: auto;
}
.yinbaono {
  font-size: 15px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
}
.orderdeline {
  font-size: 15px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #4379ee;
}

.Settlement-left {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
  padding-top: 20px;
}
.Settlement-right {
  text-align: right;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  padding-top: 32px;
}
.year {
  width: 76px;
  margin: 0 8px;
  text-align: right;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
}
/* 穿透修改element样式 不会造成全局污染 */
.year /deep/ .el-input__inner {
  text-align: right;
}
.totalprice {
  text-align: right;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
  padding-top: 30px;
  padding-bottom: 30px;
}
.paybtn {
  width: 134px;
  margin-top: 30px;
  background-color: #547cff;
}
.Settlement-right  /deep/  .el-form-item__error {
    color: #F56C6C;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    /* position: absolute; */
    top: 100%;
    right: 0;
    /* left: 0;*/
    text-align:right;
}
</style>